import { MutationObserverOptions, useMutation } from 'react-query';

import { IsetRoiInput, IsetRoiOutput, queryClient, setRoi } from 'clients/api';
import { useDlVaultContract } from 'clients/contracts/hooks';
import FunctionKey from 'constants/functionKey';

type Options = MutationObserverOptions<
    IsetRoiOutput,
  Error,
  Omit<IsetRoiInput, 'dlControllerContract'>
>;

const useSetRoi = (options?: Options) => {
  const dlControllerContract = useDlVaultContract();

  return useMutation(
    FunctionKey.SetRoi,
    (params: Omit<IsetRoiInput, 'dlControllerContract'>) =>
        setRoi({
          dlControllerContract,
        ...params,
      }),
    {
      ...options,
      onSuccess: (...onSuccessParams) => {
        // Invalidate queries related to fetching the user minted VAI amount
        queryClient.invalidateQueries(FunctionKey.GET_MINTED_USERINFO);
        queryClient.invalidateQueries(FunctionKey.GET_V_TOKEN_BALANCES_ALL);

        if (options?.onSuccess) {
          options.onSuccess(...onSuccessParams);
        }
      },
    },
  );
};

export default useSetRoi;
